import {DateRange} from '../stores/TimeIntervalStore';
import axios, {AxiosResponse} from 'axios';
import {handleError} from './errorHandling';

export function activeChannelsByDateRange(data: {interval: DateRange}): Promise<AxiosResponse<Array<{channel: string; currency: string}>>> {
    return axios.get('tableData/activeChannelDateRange', {params: data}).catch(handleError('error:loadingChannelFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/ChannelAPI.ts